var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP002(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1731,
    height: 947,
    viewBox: "0 0 1731 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_4605)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M629.521 33.0739C632.229 27.7555 634.219 22.2101 635.454 16.5369C634.219 10.8638 632.229 5.31841 629.521 0C636.015 2.21219 642.783 3.84206 649.705 4.86113C656.647 3.84734 663.434 2.21736 669.945 0C667.237 5.31841 665.247 10.8638 664.012 16.5369C665.247 22.2101 667.237 27.7555 669.945 33.0739C663.43 30.8761 656.644 29.2615 649.705 28.2582C642.786 29.2667 636.019 30.8812 629.521 33.0739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.089 411.878C414.089 411.878 423.738 391.479 423.738 384.301C423.738 377.123 413.867 356.725 413.867 356.725C413.867 356.725 438.765 364.811 447.527 364.811C456.288 364.811 481.186 356.725 481.186 356.725C481.186 356.725 471.538 377.078 471.538 384.301C471.538 391.525 481.408 411.878 481.408 411.878C481.408 411.878 456.51 403.791 447.749 403.791C438.987 403.791 414.089 411.878 414.089 411.878Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M611.221 776.872C609.02 774.237 607.161 771.42 605.676 768.467C604.191 771.42 602.332 774.237 600.131 776.872",
    fill: "url(#paint0_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M415.642 663.567C415.307 662.908 415.166 662.194 415.231 661.483C415.296 660.771 415.565 660.082 416.015 659.472C416.466 658.861 417.085 658.346 417.824 657.968C418.563 657.59 419.399 657.36 420.267 657.296C421.134 657.233 422.008 657.337 422.817 657.602C423.625 657.866 424.347 658.283 424.922 658.819C425.498 659.354 425.912 659.993 426.13 660.684C426.348 661.375 426.364 662.098 426.177 662.795C426.189 663.904 425.705 664.978 424.816 665.815C423.927 666.652 422.696 667.194 421.353 667.338C420.004 667.387 418.679 667.031 417.628 666.337C416.576 665.643 415.87 664.658 415.642 663.567Z",
    fill: "url(#paint1_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M349.709 643.441C355.304 643.049 360.48 640.851 364.099 637.333C367.717 633.814 369.483 629.263 369.006 624.678C368.526 620.087 365.848 615.838 361.557 612.859C357.266 609.88 351.711 608.413 346.104 608.777",
    fill: "url(#paint2_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M562.978 795.362C565.912 795.148 568.703 794.227 570.999 792.715C573.294 791.203 574.992 789.168 575.879 786.866C576.765 784.565 576.799 782.1 575.978 779.782C575.157 777.465 573.516 775.398 571.264 773.843C569.011 772.289 566.247 771.315 563.32 771.045C560.393 770.776 557.434 771.222 554.816 772.328C552.198 773.434 550.038 775.151 548.609 777.261C547.18 779.371 546.546 781.781 546.786 784.186C546.947 785.793 547.494 787.358 548.396 788.791C549.298 790.225 550.537 791.497 552.042 792.536C553.547 793.575 555.289 794.359 557.165 794.845C559.042 795.33 561.018 795.506 562.978 795.362Z",
    fill: "url(#paint3_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M488.007 195.854C488.411 195.223 488.99 194.679 489.698 194.265C490.406 193.851 491.223 193.58 492.082 193.472C492.942 193.365 493.821 193.425 494.647 193.647C495.473 193.869 496.224 194.247 496.839 194.751C497.454 195.255 497.916 195.87 498.187 196.547C498.458 197.224 498.531 197.944 498.4 198.648C498.269 199.352 497.938 200.022 497.433 200.602C496.928 201.182 496.263 201.656 495.493 201.987C494.446 202.437 493.251 202.601 492.082 202.455C490.914 202.309 489.833 201.861 488.997 201.176C488.161 200.491 487.614 199.605 487.436 198.648C487.258 197.691 487.458 196.712 488.007 195.854ZM389.302 227.656C390.783 228.87 392.67 229.697 394.725 230.033C396.779 230.368 398.909 230.197 400.845 229.54C402.781 228.884 404.436 227.771 405.6 226.344C406.764 224.917 407.386 223.239 407.386 221.523C407.386 219.806 406.764 218.128 405.6 216.701C404.436 215.274 402.781 214.162 400.845 213.505C398.909 212.848 396.779 212.677 394.725 213.012C392.67 213.348 390.783 214.175 389.302 215.389C387.351 217.013 386.258 219.199 386.258 221.477C386.258 223.755 387.351 225.942 389.302 227.565V227.656ZM464.273 141.609C467.238 144.031 471.013 145.679 475.12 146.345C479.227 147.011 483.484 146.664 487.351 145.349C491.218 144.034 494.522 141.81 496.847 138.957C499.172 136.104 500.413 132.75 500.413 129.32C500.413 125.89 499.172 122.536 496.847 119.683C494.522 116.831 491.218 114.606 487.351 113.291C483.484 111.976 479.227 111.63 475.12 112.295C471.013 112.961 467.238 114.609 464.273 117.031C462.3 118.643 460.734 120.558 459.666 122.667C458.598 124.776 458.048 127.037 458.048 129.32C458.048 131.603 458.598 133.864 459.666 135.973C460.734 138.082 462.3 139.997 464.273 141.609ZM611.665 233.744C613.149 234.951 615.037 235.772 617.089 236.102C619.142 236.433 621.268 236.257 623.199 235.599C625.131 234.941 626.781 233.828 627.941 232.403C629.102 230.977 629.721 229.301 629.721 227.588C629.721 225.874 629.102 224.198 627.941 222.773C626.781 221.347 625.131 220.235 623.199 219.576C621.268 218.918 619.142 218.743 617.089 219.073C615.037 219.403 613.149 220.224 611.665 221.432C609.678 223.067 608.562 225.28 608.562 227.588C608.562 229.895 609.678 232.109 611.665 233.744Z",
    fill: "url(#paint4_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M982.863 416.013C988.362 415.292 993.94 415.064 999.499 415.332C1004.54 417.135 1009.32 419.39 1013.75 422.056C1012.87 417.551 1012.61 412.979 1012.97 408.426C1015.16 404.288 1017.9 400.358 1021.13 396.705C1015.63 397.426 1010.05 397.654 1004.49 397.386C999.437 395.595 994.64 393.356 990.183 390.708C991.09 395.211 991.369 399.783 991.015 404.337C988.822 408.46 986.088 412.374 982.863 416.013Z",
    fill: "url(#paint5_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M561.536 332.056C567.035 331.337 572.613 331.108 578.172 331.375C583.227 333.18 588.025 335.435 592.479 338.098C591.6 333.593 591.321 329.024 591.647 324.469C593.85 320.328 596.602 316.397 599.854 312.748C594.355 313.467 588.777 313.696 583.218 313.429C578.163 311.624 573.365 309.369 568.911 306.706C569.79 311.211 570.068 315.781 569.743 320.335C567.54 324.476 564.787 328.407 561.536 332.056Z",
    fill: "url(#paint6_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M865.248 140.292C866.367 139.976 867.58 139.961 868.709 140.251C869.839 140.54 870.826 141.118 871.526 141.899C872.227 142.681 872.603 143.626 872.601 144.596C872.599 145.565 872.218 146.509 871.514 147.288C870.997 147.861 870.324 148.326 869.547 148.646C868.771 148.965 867.914 149.131 867.045 149.13C866.176 149.129 865.32 148.96 864.545 148.638C863.77 148.316 863.099 147.849 862.585 147.275C862.071 146.701 861.729 146.036 861.586 145.334C861.443 144.631 861.504 143.912 861.763 143.232C862.022 142.553 862.472 141.932 863.078 141.422C863.683 140.911 864.426 140.524 865.248 140.292ZM761.996 159.6C763.241 160.981 764.957 162.028 766.929 162.61C768.9 163.191 771.038 163.28 773.071 162.866C775.104 162.451 776.942 161.552 778.352 160.282C779.761 159.012 780.679 157.428 780.99 155.73C781.3 154.033 780.989 152.298 780.095 150.745C779.202 149.192 777.767 147.892 775.971 147.007C774.175 146.123 772.099 145.695 770.007 145.777C767.914 145.86 765.898 146.449 764.214 147.47C763.091 148.144 762.141 148.993 761.421 149.969C760.701 150.945 760.224 152.028 760.018 153.156C759.811 154.284 759.88 155.434 760.22 156.54C760.559 157.647 761.163 158.686 761.996 159.6ZM851.662 83.7757C854.157 86.5307 857.592 88.6182 861.535 89.7745C865.477 90.9307 869.749 91.1039 873.811 90.272C877.873 89.4401 881.543 87.6406 884.358 85.1007C887.172 82.5609 889.005 79.3946 889.624 76.0018C890.243 72.6091 889.621 69.1421 887.837 66.0388C886.052 62.9355 883.185 60.3351 879.598 58.5661C876.01 56.797 871.863 55.9388 867.681 56.0997C863.498 56.2606 859.468 57.4334 856.098 59.47C853.856 60.8254 851.962 62.5299 850.525 64.4859C849.088 66.4418 848.136 68.6109 847.724 70.8687C847.312 73.1266 847.448 75.4288 848.124 77.6436C848.799 79.8584 850.002 81.9422 851.662 83.7757ZM980.589 192.81C981.415 193.729 982.454 194.506 983.647 195.095C984.84 195.685 986.163 196.076 987.54 196.247C988.918 196.418 990.323 196.365 991.675 196.091C993.027 195.817 994.301 195.328 995.422 194.65C996.544 193.973 997.491 193.122 998.211 192.145C998.931 191.167 999.409 190.084 999.617 188.955C999.826 187.827 999.761 186.675 999.426 185.567C999.092 184.46 998.494 183.416 997.668 182.498C995.999 180.642 993.498 179.406 990.716 179.061C987.934 178.716 985.099 179.29 982.834 180.658C980.57 182.025 979.061 184.074 978.639 186.353C978.218 188.632 978.919 190.955 980.589 192.81Z",
    fill: "url(#paint7_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M1287.26 594.133C1340.92 371.826 1200.12 149.076 972.77 96.6067C745.422 44.1375 517.622 181.818 463.963 404.125C410.304 626.432 551.106 849.182 778.454 901.651C1005.8 954.12 1233.6 816.439 1287.26 594.133Z",
    fill: "url(#paint8_radial_329_4605)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M875.592 829.699C1062.27 829.699 1213.6 681.722 1213.6 499.184C1213.6 316.645 1062.27 168.668 875.592 168.668C688.914 168.668 537.582 316.645 537.582 499.184C537.582 681.722 688.914 829.699 875.592 829.699Z",
    fill: "url(#paint9_radial_329_4605)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M590.989 536.424C590.99 478.451 606.588 421.499 636.217 371.285C665.845 321.071 708.462 279.362 759.788 250.345C811.114 221.328 869.343 206.025 928.63 205.971C987.917 205.917 1046.18 221.115 1097.56 250.039C1062.01 219.795 1020.38 197.156 975.354 183.576C930.326 169.996 882.891 165.775 836.096 171.184C789.3 176.593 744.18 191.513 703.631 214.986C663.083 238.458 628.003 269.964 600.646 307.479C573.288 344.995 554.258 387.691 544.777 432.824C535.296 477.958 535.573 524.532 545.592 569.555C555.611 614.578 575.149 657.054 602.952 694.255C630.755 731.456 666.207 762.56 707.033 785.568C670.562 754.596 641.326 716.321 621.304 673.335C601.283 630.349 590.944 583.658 590.989 536.424Z",
    fill: "#F1AD39"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M700.267 724.102C658.33 683.122 628.158 632.074 612.781 576.084C597.404 520.094 597.364 461.134 612.664 405.124C627.964 349.114 658.067 298.026 699.948 256.992C741.829 215.957 794.015 186.421 851.264 171.348C804.241 174.517 758.415 187.27 716.733 208.79C675.051 230.309 638.434 260.117 609.236 296.3C580.038 332.482 558.904 374.237 547.194 418.882C535.483 463.527 533.454 510.073 541.237 555.531C549.02 600.988 566.444 644.35 592.387 682.83C618.331 721.311 652.221 754.058 691.879 778.967C731.538 803.877 776.087 820.397 822.664 827.467C869.242 834.537 916.816 832 962.331 820.019C914.172 823.319 865.85 816.463 820.637 799.914C775.424 783.366 734.374 757.512 700.267 724.102Z",
    fill: "#E7277F"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M1142.07 295.974C1159.6 369.32 1150.98 446.321 1117.63 514.218C1084.28 582.115 1028.21 636.831 958.703 669.301C889.198 701.771 810.433 710.044 735.461 692.75C660.489 675.456 593.81 633.633 546.474 574.211C557.942 622.356 580.312 667.372 611.933 705.943C643.555 744.513 683.624 775.655 729.187 797.074C774.751 818.493 824.648 829.644 875.203 829.704C925.759 829.765 975.684 818.733 1021.3 797.423C1066.92 776.113 1107.06 745.067 1138.78 706.572C1170.5 668.078 1192.98 623.115 1204.57 574.997C1216.16 526.879 1216.56 476.832 1205.74 428.542C1194.93 380.252 1173.17 334.95 1142.07 295.974Z",
    fill: "url(#paint10_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M1205.83 563.712C1190.31 583.841 1172.5 602.186 1152.76 618.397C1098.87 662.785 1032.13 689.59 961.891 695.06C891.651 700.53 821.42 684.391 761.023 648.903C700.627 613.414 653.087 560.351 625.056 497.137C597.025 433.924 589.905 363.723 604.692 296.357C574.344 335.901 553.456 381.6 543.568 430.086C533.68 478.572 535.045 528.609 547.561 576.511C560.076 624.413 583.425 668.959 615.885 706.865C648.346 744.771 689.091 775.073 735.118 795.536C781.146 816 831.282 826.104 881.833 825.103C932.385 824.103 982.062 812.024 1027.21 789.757C1072.35 767.49 1111.81 735.602 1142.67 696.443C1173.54 657.283 1195.02 611.851 1205.55 563.493L1205.83 563.712Z",
    fill: "url(#paint11_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1122.72 353.666L968.147 445.1C952.656 454.232 936.717 463.802 926.539 478.403C916.36 493.004 913.396 514.003 924.693 527.619C935.99 541.236 956.011 543.259 973.907 544.025L1065.79 548.782C1089.78 549.985 1120.09 556.329 1124.46 579.46C1127.42 595.374 1115.56 613.365 1124.46 627.2C1128.8 633.005 1135.06 637.159 1142.18 638.957C1154.41 642.836 1167.33 644.123 1180.1 642.731C1204.97 592.392 1216.38 536.707 1213.26 480.884C1210.14 425.061 1192.6 370.924 1162.26 323.535C1150.92 335.698 1137.55 345.887 1122.72 353.666Z",
    fill: "url(#paint12_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M909.874 828.003C902.365 823.786 894.262 820.672 885.826 818.761C869.72 814.715 850.37 806.239 850.258 789.942C850.561 784.551 852.296 779.33 855.292 774.795C878.5 735.039 928.665 720.875 969.658 698.837C980.172 693.369 991.636 684.291 990.294 672.643C988.649 665.406 984.147 659.096 977.767 655.09C947.568 631.903 906.407 624.849 868.658 631.575C830.908 638.301 796.403 657.714 767.601 682.487C755.354 692.986 743.554 704.743 728.454 710.157C713.354 715.571 693.109 712.181 685.671 698.072C679.743 686.861 683.546 672.972 680.079 660.831C673.983 640.543 648.146 631.247 626.95 635.676C609.614 639.286 594.85 649.512 581.036 660.722C610.387 711.965 653.179 754.629 705.002 784.321C756.826 814.012 815.808 829.657 875.872 829.644C887.281 829.644 898.615 829.097 909.874 828.003Z",
    fill: "url(#paint13_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M536.756 469.018C546.695 472.041 556.232 476.208 565.166 481.432C601.181 502.485 629.088 534.913 665.047 556.077C694.977 573.638 729.299 582.743 764.202 582.38C781.586 582.995 798.78 578.664 813.696 569.912C828.012 560.451 837.799 543.116 834.108 526.601C828.516 501.173 795.744 489.634 786.404 465.245C777.065 440.856 795.967 413.076 819.456 400.061C842.944 387.046 870.627 383.163 895.514 372.718C920.926 362.228 942.972 345.224 959.324 323.502C977.164 299.659 987.286 267.067 974.368 240.381C961.449 213.695 931.417 202.101 909.271 182.743C904.829 178.891 900.627 174.783 896.688 170.439C888.915 169.947 881.141 169.564 873.2 169.564C789.065 169.581 707.961 200.279 645.743 255.657C583.524 311.036 544.663 387.113 536.756 469.018Z",
    fill: "url(#paint14_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M901.317 448.382C901.317 453.584 899.74 458.669 896.784 462.995C893.828 467.321 889.627 470.692 884.712 472.683C879.796 474.674 874.388 475.194 869.17 474.18C863.951 473.165 859.158 470.659 855.396 466.981C851.634 463.302 849.072 458.615 848.034 453.513C846.997 448.411 847.529 443.122 849.565 438.316C851.601 433.509 855.049 429.401 859.473 426.511C863.896 423.621 869.097 422.078 874.417 422.078C881.552 422.078 888.394 424.849 893.438 429.782C898.483 434.715 901.317 441.405 901.317 448.382Z",
    fill: "url(#paint15_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M1031.12 342.074C1039.52 342.074 1046.33 335.414 1046.33 327.199C1046.33 318.985 1039.52 312.325 1031.12 312.325C1022.72 312.325 1015.91 318.985 1015.91 327.199C1015.91 335.414 1022.72 342.074 1031.12 342.074Z",
    fill: "url(#paint16_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M1109.47 685.113C1109.47 691.453 1107.55 697.651 1103.94 702.922C1100.34 708.193 1095.22 712.3 1089.23 714.724C1083.23 717.148 1076.64 717.779 1070.28 716.538C1063.93 715.297 1058.09 712.24 1053.5 707.753C1048.92 703.266 1045.81 697.551 1044.55 691.331C1043.29 685.111 1043.95 678.666 1046.44 672.812C1048.93 666.957 1053.13 661.956 1058.53 658.441C1063.93 654.927 1070.27 653.057 1076.75 653.067C1081.05 653.067 1085.31 653.897 1089.29 655.508C1093.26 657.119 1096.87 659.48 1099.91 662.457C1102.95 665.433 1105.35 668.966 1107 672.854C1108.64 676.741 1109.48 680.907 1109.47 685.113Z",
    fill: "url(#paint17_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M920.053 593.624C920.053 596.339 919.23 598.992 917.687 601.25C916.145 603.507 913.952 605.266 911.387 606.305C908.822 607.344 906 607.616 903.277 607.086C900.554 606.556 898.053 605.249 896.09 603.33C894.127 601.41 892.79 598.964 892.248 596.302C891.707 593.639 891.985 590.879 893.047 588.371C894.109 585.863 895.909 583.719 898.217 582.211C900.525 580.703 903.239 579.898 906.016 579.898C909.734 579.912 913.296 581.363 915.925 583.934C918.554 586.505 920.038 589.988 920.053 593.624Z",
    fill: "url(#paint18_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M737.402 650.77C737.413 653.044 736.734 655.269 735.45 657.165C734.167 659.061 732.336 660.541 730.191 661.419C728.046 662.296 725.683 662.531 723.401 662.095C721.12 661.658 719.022 660.568 717.374 658.964C715.726 657.361 714.602 655.314 714.144 653.085C713.686 650.856 713.915 648.544 714.803 646.443C715.69 644.341 717.195 642.544 719.128 641.28C721.06 640.016 723.333 639.341 725.658 639.341C727.198 639.334 728.724 639.624 730.148 640.195C731.573 640.766 732.868 641.607 733.959 642.669C735.05 643.731 735.916 644.993 736.507 646.384C737.098 647.774 737.402 649.265 737.402 650.77Z",
    fill: "url(#paint19_radial_329_4605)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1026.77 916.362C1021.2 919.875 1016.12 923.878 1011.62 928.3C1009.26 933.728 1007.63 939.352 1006.76 945.072C1002.46 940.506 997.573 936.334 992.181 932.629C985.541 930.681 978.664 929.332 971.67 928.604C977.239 925.09 982.322 921.087 986.827 916.666C989.187 911.238 990.815 905.614 991.682 899.894C996.008 904.456 1000.92 908.622 1006.34 912.32C1012.95 914.263 1019.81 915.618 1026.77 916.362Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1248.11 832.711C1247.38 833.094 1246.54 833.33 1245.68 833.401C1244.81 833.472 1243.94 833.375 1243.13 833.118C1242.32 832.861 1241.59 832.451 1241.01 831.921C1240.43 831.392 1240 830.758 1239.77 830.07C1239.54 829.382 1239.52 828.66 1239.69 827.962C1239.86 827.264 1240.24 826.609 1240.78 826.051C1241.32 825.493 1242.01 825.047 1242.8 824.75C1243.59 824.452 1244.45 824.31 1245.32 824.337C1246.5 824.373 1247.64 824.718 1248.56 825.32C1249.49 825.923 1250.16 826.753 1250.47 827.687C1250.78 828.622 1250.72 829.614 1250.29 830.518C1249.87 831.421 1249.1 832.19 1248.11 832.711ZM1353.03 845.315C1352.48 843.658 1351.34 842.171 1349.76 841.043C1348.18 839.914 1346.23 839.196 1344.15 838.977C1342.07 838.758 1339.96 839.05 1338.09 839.814C1336.22 840.579 1334.66 841.782 1333.62 843.272C1332.58 844.762 1332.11 846.472 1332.25 848.185C1332.4 849.898 1333.17 851.538 1334.45 852.896C1335.73 854.255 1337.48 855.271 1339.46 855.817C1341.45 856.363 1343.59 856.414 1345.61 855.963C1348.28 855.349 1350.56 853.896 1351.93 851.918C1353.31 849.941 1353.69 847.598 1352.98 845.394L1353.03 845.315ZM1235.89 889.466C1234.78 886.156 1232.5 883.188 1229.34 880.937C1226.17 878.686 1222.27 877.253 1218.12 876.819C1213.97 876.385 1209.75 876.969 1206.01 878.499C1202.26 880.028 1199.16 882.434 1197.08 885.411C1195 888.389 1194.05 891.805 1194.34 895.229C1194.64 898.652 1196.16 901.93 1198.72 904.646C1201.28 907.363 1204.77 909.398 1208.73 910.493C1212.7 911.589 1216.98 911.696 1221.02 910.801C1223.7 910.206 1226.22 909.181 1228.43 907.786C1230.63 906.39 1232.47 904.652 1233.86 902.67C1235.24 900.688 1236.13 898.501 1236.48 896.236C1236.83 893.97 1236.62 891.67 1235.89 889.466ZM1163.69 749.445C1163.13 747.792 1161.99 746.311 1160.41 745.188C1158.83 744.065 1156.88 743.351 1154.8 743.136C1152.73 742.921 1150.62 743.214 1148.75 743.979C1146.88 744.744 1145.33 745.946 1144.29 747.433C1143.26 748.921 1142.78 750.628 1142.93 752.338C1143.07 754.048 1143.83 755.686 1145.11 757.044C1146.39 758.403 1148.13 759.421 1150.11 759.97C1152.09 760.52 1154.22 760.576 1156.24 760.132C1158.96 759.523 1161.27 758.056 1162.66 756.053C1164.06 754.05 1164.43 751.674 1163.69 749.445Z",
    fill: "url(#paint20_radial_329_4605)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M887.023 727.264C885.861 727.082 884.799 726.601 883.993 725.889C883.188 725.178 882.68 724.275 882.546 723.311C882.411 722.347 882.656 721.373 883.244 720.533C883.833 719.692 884.735 719.028 885.817 718.638C886.612 718.351 887.478 718.222 888.345 718.261C889.213 718.299 890.057 718.505 890.811 718.86C891.564 719.215 892.205 719.71 892.683 720.305C893.16 720.901 893.461 721.58 893.56 722.287C893.659 722.995 893.553 723.711 893.252 724.379C892.952 725.047 892.463 725.647 891.827 726.131C891.191 726.616 890.425 726.97 889.59 727.167C888.756 727.364 887.877 727.397 887.023 727.264ZM988.334 752.566C988.089 750.86 987.232 749.251 985.873 747.944C984.513 746.636 982.711 745.688 980.696 745.219C978.68 744.751 976.541 744.782 974.549 745.311C972.557 745.839 970.801 746.84 969.505 748.187C968.208 749.534 967.428 751.167 967.264 752.879C967.1 754.591 967.559 756.305 968.583 757.804C969.607 759.303 971.15 760.52 973.016 761.301C974.883 762.082 976.989 762.392 979.069 762.191C980.451 762.064 981.789 761.714 983.005 761.16C984.221 760.606 985.29 759.86 986.152 758.965C987.013 758.07 987.65 757.044 988.024 755.945C988.399 754.847 988.504 753.698 988.334 752.566ZM864.62 781.857C864.121 778.449 862.402 775.238 859.68 772.628C856.957 770.018 853.354 768.128 849.324 767.195C845.295 766.262 841.02 766.329 837.04 767.387C833.06 768.446 829.553 770.448 826.963 773.14C824.373 775.833 822.815 779.096 822.486 782.517C822.157 785.938 823.073 789.363 825.116 792.36C827.16 795.357 830.241 797.791 833.969 799.356C837.697 800.92 841.905 801.544 846.062 801.148C848.829 800.885 851.504 800.177 853.935 799.065C856.366 797.952 858.504 796.457 860.228 794.665C861.952 792.873 863.227 790.819 863.981 788.621C864.734 786.424 864.951 784.125 864.62 781.857ZM818.679 634.688C818.518 633.554 818.085 632.457 817.407 631.459C816.728 630.461 815.817 629.582 814.725 628.873C813.632 628.163 812.381 627.637 811.041 627.324C809.701 627.011 808.3 626.917 806.916 627.048C805.533 627.179 804.195 627.532 802.979 628.087C801.763 628.642 800.693 629.388 799.829 630.283C798.965 631.178 798.325 632.203 797.945 633.301C797.565 634.399 797.452 635.548 797.614 636.683C797.94 638.973 799.362 641.065 801.568 642.498C803.774 643.931 806.583 644.587 809.376 644.323C812.17 644.058 814.719 642.894 816.464 641.088C818.209 639.281 819.006 636.979 818.679 634.688Z",
    fill: "url(#paint21_radial_329_4605)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.859 997.396) scale(416.724 341.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(420.91 663.204) scale(5.32342 4.36139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.583 626.132) scale(17.0239 13.9474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(561.703 783.141) scale(14.9721 12.2664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(496.688 215.264) rotate(-140.673) scale(89.3664 87.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1001.88 406.427) scale(19.0756 15.6283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.612 322.47) scale(19.0756 15.6283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(879.776 126.254) scale(104.25 85.4106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(875.58 499.132) scale(422.96 413.582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA4993",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7E9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(757.423 250.149) scale(715.223 699.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#743B8F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(917.87 536.533) scale(592.971 579.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(872.944 552.758) rotate(49.6349) scale(586.017 588.281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(677.114 -120.123) scale(571.831 559.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#743B8F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(677.115 -120.123) scale(571.831 559.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#743B8F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(674.722 -119.172) scale(571.831 559.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#70C7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#743B8F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.28 355.745) scale(571.607 558.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.278 355.745) scale(571.607 558.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.28 355.746) scale(571.608 558.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.281 355.745) scale(571.608 558.933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(887.281 355.745) scale(571.608 558.934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D1085B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#692980"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1252.32 812.326) rotate(71.5895) scale(81.4949 96.0832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1F264D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#067AB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_329_4605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(865.917 733.531) rotate(-154.859) scale(99.9641 89.0727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1085B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_4605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1038.31,
    height: 946.982,
    fill: "white",
    transform: "translate(346.105)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP002);
export default __webpack_public_path__ + "static/media/p002.6d74d7a58ae915412902aaffbb8233f5.svg";
export { ForwardRef as ReactComponent };